<template>
  <div class="page-content-area">
    <skeleton-detail v-if="pageLoadingShow" />
    <div v-else class="offer-detail-container" :class="{ 'mini-detail-container': isWxMini && !showNav }">
      <w-nav-bar nav_title="职位详情" v-if="!isWxMini || showNav" @mobileLeftBtn="pageBack"/>
      <template v-if="!jobEmpty">
        <div class="offer-detail-content">
          <div class="offer-detail-info flex">
            <img class="company-logo" :src="campusOfferDetailData.company_logo || companyInformation.company_logo || 'https://files.wondercv.com/icon/Artboard.png'" alt="">
            <div class="job-offer-detail flex-column">
              <div class="flex-start" style="margin-bottom: 6px">
                <span class="offer-detail-title">{{ campusOfferDetailData.company_name || companyInformation.company_name }}</span>
                <div class="flex-center" v-if="campusOfferDetailData.info_type"
                     :class="`detail-info-type-${campusOfferDetailData.info_type === '实习' ? 1 : 2}`">
                  <span>{{campusOfferDetailData.info_type}}</span>
                </div>
              </div>
              <div class="flex-start">
                <span class="info-item flex-center" v-if="campusOfferDetailData.category">{{ campusOfferDetailData.category }}</span>
                <span class="info-item flex-center" v-if="token !== 'empty_token'">{{ campusOfferDetailData.city_names | cityFilter }}</span>
                <span class="info-item flex-center" v-if="campusOfferDetailData.display_time">{{ campusOfferDetailData.display_time }}</span>
                <span class="info-item flex-center" v-if="companyInformation.industry">{{companyInformation.industry}}</span>
                <span class="info-item flex-center" v-if="companyInformation.scale">{{companyInformation.scale}}</span>
              </div>
            </div>
          </div>
          <div class="block-detail-info flex-between" v-if="campusOfferDetailData.url">
            <div class="flex-start">
              <span style="color: #212121">投递链接：</span>
              <div class="link-url">{{ campusOfferDetailData.url }}</div>
            </div>
            <div class="link-copy flex-center url-copy" :data-clipboard-text="campusOfferDetailData.url" @click="campusOfferOperation">复制</div>
          </div>
          <div class="campus-calendar-deal flex-start" style="margin-bottom: 36px;" :class="{'deal-system-active': dealType === 'me' && token !== 'empty_token'}">
            <div v-if="token !== 'empty_token'" class="deal-item" :class="{'deal-item-active': dealType === 'campus'}" @click="changeDealType('campus')">校招日程</div>
            <div class="deal-item" :class="{'deal-item-active': dealType === 'me'}" @click="changeDealType('me')">我的待办</div>

            <div class="all-calendar" @click="toCampusManage"><span>全部待办</span><i class="iconfont iconchevron-right"></i></div>
          </div>
          <transition name="fade">
            <div v-show="dealType === 'campus'">
              <div class="block-detail-info flex-column">
                <span class="block-title" style="margin-bottom: 16px;">校招日程</span>
                <template v-for="(item, index) in campusOfferDetailData.comp_recruit_schedule">
                  <div class="daily-item flex-start" :key="index" v-if="item.type != '内推'">
                    <div class="iconfont-content flex-column-center">
                      <div class="dot"/>
                    </div>
                    <div class="daily-item-content flex-between">
                      <span class="daily-title">{{ item.type }}</span>
                      <span class="daily-time">{{ item.value || recruitScheduleData.get(item.type) }}</span>
                    </div>
                  </div>
                </template>
              </div>
              <div class="block-detail-info flex-column" v-if="campusOfferDetailData.internal_recommend_count">
                <span class="block-title">职位内推</span>
                <div class="block-jobs-introduction flex-between" @click="goToApp">
                  <div class="flex-start">
                    <div class="company-logos flex-start">
                      <template v-for="(val, index) in campusOfferDetailData.internal_recommend_avatar_url">
                        <img :src="val" :key="index" alt="">
                      </template>
                    </div>
                    <span class="introduction-text">{{ campusOfferDetailData.internal_recommend_count }}名用户可以帮你内推</span>
                  </div>
                  <i class="iconfont iconchevron-right"/>
                </div>
              </div>
              <div class="block-detail-info flex-column">
                <span class="block-title">笔面经</span>
                <div class="block-jobs-introduction flex-between" @click="goToApp">
                  <div class="flex-start">
                    <div class="company-logos flex-start">
                      <img src="https://files.wondercv.com/m/daniu/touxiang.png" style="border-radius: 0;border: none;width: 69px;height: 30px">
                    </div>
                    <span class="introduction-text">已有122名用户分享最新笔面经</span>
                  </div>
                  <i class="iconfont iconchevron-right"/>
                </div>
              </div>
              <div class="block-detail-info flex-column">
                <span class="block-title">校招详情</span>
                <div v-html="campusOfferDetailData.desc" class="campus-offer-desc" />
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div v-show="dealType === 'me'">
              <template v-for="(item, index) in compRecruitInfos">
                <div class="daily-item flex-start daily-thing-item" :key="index">
                  <div class="iconfont-content flex-column-center">
                    <div class="dot"/>
                  </div>
                  <div class="daily-item-content daily-item-info">
                    <span class="daily-title">{{item.date}}</span>
                    <template v-for="(value, i) in item.infos">
                      <div class="daily-content flex-column" @click="toEditCampusRecruitment(value)"
                           :class="value.finished === 0 ? 'daily-give-up' : value.finished === 1 ? 'daily-complete' : ''" :key="i">
                        <span class="step-type">{{ value.step_type }}</span>
                        <div class="flex-start">
                          <i class="iconfont iconshizhong"></i>
                          <span>{{ value.execute_at | timeFilter('HH:mm') }}</span>
                        </div>
                        <div class="flex-start" v-if="value.address">
                          <i class="iconfont iconxianjuchengshi"></i>
                          <span>{{ value.address }}</span>
                        </div>
                        <div class="flex-start" v-if="value.remark">
                          <i class="iconfont iconbookmark"></i>
                          <span>{{ value.remark }}</span>
                        </div>
                        <div class="daily-operation" v-if="value.finished === 2">
                          <i class="iconfont iconxuanzhong" @click.stop="updateCampusRecruitmentState(value, 1)"></i>
                          <i class="iconfont iconshanchu1" @click.stop="updateCampusRecruitmentState(value, 0)"></i>
                        </div>
                        <div class="daily-operation daily-complete-btn white-button flex-center" v-if="value.finished === 1" @click.stop="toggleStatus(value)">已完成</div>
                        <div class="daily-operation daily-complete-btn white-button flex-center give-up-btn" v-if="value.finished === 0" @click.stop="toggleStatus(value)">已放弃</div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
              <div class="daily-item flex-start daily-thing-item">
                <div class="iconfont-content flex-column-center">
                  <div class="dot"/>
                </div>
                <div class="add-daily flex-center" @click="addCompRecruit">添加待办</div>
              </div>
            </div>
          </transition>
        </div>
        <transition name="fade">
          <div class="footer flex-start footer-content" v-show="dealType === 'campus'">
            <template v-if="!campusOfferDetailData.is_end">
              <button class="footer-btn white-button flex-center"
                      :class="{ 'job-is-liked': campusOfferDetailData.job_is_liked }"
                      @click="debounce(() => {campusOfferCollect(campusOfferDetailData)}, 300)">
                <i class="iconfont iconcvs-chuangjian" v-if="!campusOfferDetailData.job_is_liked" />
                <span>{{ campusOfferDetailData.job_is_liked | jobLikeFilter }}</span>
              </button>
              <button class="footer-btn theme-button url-copy" :data-clipboard-text="campusOfferDetailData.url" @click="campusOfferOperation">网申投递</button>
            </template>
            <button v-else class="footer-btn flex-center overdue-btn">网申已过期</button>
          </div>
        </transition>
      </template>
      <w-no-result v-else>
        <div slot="resultContent" class="result-content flex-column">
          <p class="title">该职位已下线</p>
          <p class="sub-title">查看推荐职位，更多 Offer 等你拿</p>
          <button class="theme-button flex-center" @click="pageBack">查看更多职位</button>
        </div>
      </w-no-result>
      <attention-dialog :dialog-state="attentionState" @handleClose="changeAttentionState" @toCampusManage="toCampusManage" />
    </div>
  </div>
</template>

<script>
  import WNavBar from '../../../../components/global/w-navbar'
  import WNoResult from '../../../../components/global/w-no-result'
  import WLoading from '../../../../components/global/w-loading'
  import SkeletonDetail from '../../components/skeleton-detail'
  import {envMixin, loginMixin} from "../../../../assets/js/mixin/global";
  import {componentsMixin} from "../../../../assets/js/mixin/components";
  import {campusOfferMixin} from "../../../../assets/js/mixin/jobs";
  import Clipboard from "clipboard";
  import {userMixin} from "../../../../assets/js/mixin/user";
  export default {
    name: 'job-campus-offers-detail',
    mixins: [ envMixin, componentsMixin, campusOfferMixin, loginMixin, userMixin ],
    data() {
      return {
        campusOfferDetailData: {}, // 校招详情的数据
        jobEmpty: false,
        pageLoadingShow: true,
        recruitScheduleData: new Map([['内推', '以官网信息为准'], ['网申', '以官网信息为准'], ['笔试', '以官网信息为准'], ['面试', '分批次进行'], ['offer', '面试结束后']]),
        dealType: 'campus',
        compRecruitInfos: [],
        companyInformation: {},
        token: '',
        showNav: '',
      }
    },
    async mounted() {
      this.initShowNav()
      await this.loginByWx()
      this.getUserAccountData()
      this.getCampusOfferDetail()
      this.getCampusRecruitmentInfos()
    },
    async activated() {
      this.getUserAccountData()
      this.getCampusOfferDetail()
      this.getCampusRecruitmentInfos()
    },
    deactivated() {
      this.pageLoadingShow = true,
      this.jobEmpty = false
    },
    computed: {},
    watch: {},
    components: {
      WNavBar,
      WNoResult,
      WLoading,
      SkeletonDetail,
    },
    methods: {
      // 切换状态
      toggleStatus (value) {
        this.$api.campusOffers.updateCampusRecruitmentState(value.id, { finished: 2 }).then(res => {
          if (res.code === 1000) {
            value.finished = 2
          }
        }).catch(e => console.log(e))
      },
      initShowNav() {
        let { tab } = this.$route.query
        this.showNav = this.$db.ls.get('showNav')
        this.$db.ls.remove('showNav')
        if (tab) this.dealType = tab
      },
      // 改变type
      changeDealType(type) {
        this.dealType = type
      },
      // 右滑
      thingsSwipeRight() {
        this.dealType = 'campus'
      },
      // 左滑
      thingsSwipeLeft() {
        this.dealType = 'me'
      },
      // 分享事件
      onShareMessage() {
        try {
          setTimeout(() => {
            this.$wechat.miniProgram.postMessage({
              data: {
                title: `最新｜${ this.campusOfferDetailData.company_name }`,
                description: '查看详情获取最新大厂校招内推信息'
              }
            })
          }, 1500)
        } catch (e) {
          console.log(e)
        }
      },
      // 页面返回事件
      pageBack() {
        if (this.isWxMini && !this.showNav) {
          this.$wechat.miniProgram.navigateBack()
        } else {
          this.$router.back()
        }
      },
      // 添加待办
      addCompRecruit() {
        if (!this.alreadyLogged) {
          this.needLogin()
          return
        }
        let campusToken = this.$route.params.token
        let params = {}
        if (campusToken === 'empty_token') {
          let { company_name } = this.companyInformation
          params = {
            company_token: this.$route.query.company_token,
            company_name
          }
        } else {
          let { company_token, company_nick_name, token, company_name } = this.campusOfferDetailData
          params = {
            company_token,
            company_name: company_nick_name,
            comp_name: company_name,
            comp_recruit_info_token: token,
          }
        }
        this.$router.push({
          name: 'campus-thing-create',
          params
        })
      },
      // 跳转下载App
      async goToApp() {
        let res = await this.$api.jobs.getTeamInfo()
        let completed = false
        if(res.code === 1000){
          completed = res.data.completed
          if(!completed){
            if (this.isWxMini) {
              this.$wechat.miniProgram.navigateTo({
                url: `/pages/fission/fission`
              })
              return
            }
          }
        }
        this.$router.push({ path: '/welcome/to_app', query: { type: 'campusOffer' } })
      },
      // 编辑步骤
      toEditCampusRecruitment(item) {
        this.$router.push({ path: '/jobs/campus/thing/create', query: { id: item.id } })
      },
      // 点击网申投递或者复制
      campusOfferOperation() {
        if (this.alreadyLogged) {
          let { has_cv, has_cv_over_60 } = this.campusOfferDetailData
          if (!has_cv || !has_cv_over_60) {
            this.verifyUserCv()
            this.copyUrl({ hideToast: true })
          } else {
            this.copyUrl()
          }
        } else {
          this.needLogin()
        }
      },
      // 判断用户简历状态
      verifyUserCv() {
        let { has_cv, has_cv_over_60 } = this.campusOfferDetailData
        this.$createDialog({
          type: 'confirm',
          content: !has_cv ? '你还没有创建简历，建议创建简历后网申' : !has_cv_over_60 ? '你的简历信息尚不完善，建议完善简历后网申' : '',
          confirmBtn: { text: !has_cv ? '快速创建' : !has_cv_over_60 ? '去完善' : '' },
          cancelBtn: { text: !has_cv ? '先不创建' : !has_cv_over_60 ? '先不完善' : '' },
          onConfirm: () => { this.$router.push('/cvs') },
          onCancel: () => { this.showToast('投递链接已复制', 1500) }
        }).show()
      },
      // 复制网申地址
      copyUrl (params = {}) {
        let clipboard = new Clipboard('.url-copy')
        clipboard.on('success', e => {
          if (!params.hideToast) this.showToast('投递链接已复制', 1500)
          clipboard.destroy() // 释放内存
        })
      },
      // 获取网申详情数据
      getCampusOfferDetail() {
        let { token } = this.$route.params
        this.token = token
        this.campusOfferDetailData = {}
        if (token !== 'empty_token') {
          this.$api.campusOffers.getCampusOfferDetail(token).then(res => {
            if (res.code === 1000) {
              this.campusOfferDetailData = res.data
              this.$route.meta.shareByWx('查看详情获取最新大厂校招内推信息', { title: `最新｜${ this.campusOfferDetailData.company_name }` })
              this.onShareMessage()
              document.title = this.campusOfferDetailData.company_name
            } else {
              this.showToast('服务器开小差了，请稍后再试')
            }
            this.pageLoadingShow = false
          }).catch(() => {
            this.jobEmpty = true
            this.pageLoadingShow = false
          })
        } else {
          this.dealType = 'me'
        }
      },
      // 获取特定网申的个人待办
      getCampusRecruitmentInfos() {
        if (this.alreadyLogged) {
          let { token } = this.$route.params
          let { company_token } = this.$route.query
          let apiRequest = token !== 'empty_token' ? this.$api.campusOffers.getRecruitmentInfoByCampusToken : this.$api.campusOffers.getRecruitmentInfoByCompanyToken
          let requestToken = token !== 'empty_token' ? token : company_token
          apiRequest(requestToken).then(res => {
            if (res.code === 1000) {
              this.compRecruitInfos = token === 'empty_token' ? res.data.recruitments : res.data
              this.dealCompRecruitInfos()
              if (token === 'empty_token') {
                this.companyInformation = res.data.company
              }
            }
            this.pageLoadingShow = false
          }).catch(e => {
            this.pageLoadingShow = false
            console.log(e)
          })
        }
      },
      dealCompRecruitInfos() {
        const moment = require('moment')
        const keyForArray = {}
        let compRecruitInfos = []
        this.compRecruitInfos.forEach(item => keyForArray[moment(item.execute_at).format('YYYY.MM.DD')] = 1)
        const keys = Object.keys(keyForArray).sort((a, b) => a.replace('.', '') - b.replace('.', ''))
        for (let i = 0; i < keys.length; i++) {
          const infos = this.compRecruitInfos.filter(item => moment(item.execute_at).format('YYYY.MM.DD') === keys[i])
          compRecruitInfos.push({
            date: keys[i],
            infos
          })
        }
        this.compRecruitInfos = compRecruitInfos
      },
      // 更改网申步骤的状态
      updateCampusRecruitmentState(item, finished) {
        this.$api.campusOffers.updateCampusRecruitmentState(item.id, { finished }).then(res => {
          if (res.code === 1000) {
            item.finished = finished
          }
        }).catch(e => console.log(e))
        // const content = finished ? '真的已经搞定了吗？' : '真的不做这件事了吗？'
        // this.$createDialog({
        //   title: '确认提示',
        //   type: 'confirm',
        //   content,
        //   confirmBtn: { text: finished ? '搞定了' : '不做了' },
        //   cancelBtn: { text: finished ? '还没' : '接着做' },
        //   onConfirm: () => {
        //     this.$api.campusOffers.updateCampusRecruitmentState(item.id, { finished }).then(res => {
        //       if (res.code === 1000) {
        //         item.finished = finished
        //       }
        //     }).catch(e => console.log(e))
        //   },
        // }).show()
      },
      // 获取用户数据
      getUserAccountData() {
        let keys = Object.keys(this.userData || {})
        if (keys && !keys.length) {
          this.getUserData()
        }
      },
    },
    filters: {
      infoTypeFilter(val) {
        return val === 1 ? '实习' : val === 2 ? '全职' : ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/scss/global/variable";
  @import "../../../../assets/scss/global/mixin";
  @import "../../styles/no-result";
  @import "./index";
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
